// @ts-nocheck
import { newGuid } from "@insite/client-framework/Common/StringHelpers";
import getFileExtension from "@insite/client-framework/Common/Utilities/getFileExtension";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setUploadCancelled from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetUploadCancelled";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers from "@insite/content-library/Components/ProductPartNumbers";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import DatePicker, { DatePickerState } from "@insite/mobius/DatePicker";
import FileUpload, { FileUploadPresentationProps } from "@insite/mobius/FileUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridWidths } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img";
import ListItem, { ListItemProps, UnorderedList, UnorderedListProps } from "@insite/mobius/Lists";
import Radio from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import Select from "@insite/mobius/Select";
import TextField from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import LoadingOverlay, { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { infoProps } from "@store/Themes/common/props/info";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { ScratchAndDentsProductParameter } from "@store/Framework/Services/ScratchAndDentService";
import addProduct from "@store/Framework/Store/Store/Components/ScratchAndDentForm/Handlers/AddProduct";
import editProduct from "@store/Framework/Store/Store/Components/ScratchAndDentForm/Handlers/EditProduct";
import resetProduct from "@store/Framework/Store/Store/Components/ScratchAndDentForm/Handlers/ResetProduct";
import setSndGrades from "@store/Framework/Store/Store/Components/ScratchAndDentForm/Handlers/SetSndGrades";
import { getProductSelector } from "@store/Framework/Store/Store/Components/ScratchAndDentForm/ScratchAndDentFormSelectors";
import ScratchAndDentProductSearch from "@store/Library/Components/ScratchAndDent/ScratchAndDentProductSearch";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { buttonThemeStyles } from "@toolkit/Themes/common/mixins";
import React, { ChangeEvent, FormEvent, useContext, useEffect, useState } from "react";
import Resizer from "react-image-file-resizer";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

export enum SndMode {
    Create = "Create",
    Edit = "Edit",
}

export interface FileInfo {
    FileStream: string | [];
    FileName: string;
    IsDelete?: boolean | string;
    IsExistingImage?: boolean | string;
    MediumImagePath?: string;
}

const mapStateToProps = (state: ApplicationState) => {
    const { isSearching, selectedProductInfo, originalSelectedProductInfo } = getProductSelector(state);
    const product = getProductState(state, selectedProductInfo?.productId).value;
    const originalProduct = getProductState(state, originalSelectedProductInfo?.productId).value;
    return {
        state,
        isSearching,
        product,
        originalProduct,
        sndGrades: state.store.components.scratchAndDentForm.sndGrades,
        isSubmitting: state.store.components.scratchAndDentForm.isSubmitting,
    };
};

const mapDispatchToProps = {
    resetProduct,
    setSndGrades,
    addProduct,
    editProduct,
};

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme>;

export interface ScratchAndDentFormStyles {
    container?: GridContainerProps;
    sndModeGridItem?: GridItemProps;
    sndModeRadioGroup?: RadioGroupProps;
    formContainer?: GridContainerProps;
    parentProductSearchGridItem?: GridItemProps;
    originalProductContainerGridItem?: GridItemProps;
    originalProductContainer?: GridContainerProps;
    originalProductLabelGridItem?: GridItemProps;
    originalProductLabel?: TypographyProps;
    originalProductImageGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    originalProductPartNumbersGridItem?: GridItemProps;
    productDescription?: ProductDescriptionStyles;
    serialNumberGridItem?: GridItemProps;
    gradeGridItem?: GridItemProps;
    additionalDescriptionGridItem?: GridItemProps;
    statusGridItem?: GridItemProps;
    activateOnGridItem?: GridItemProps;
    fileUploadGridItem?: GridItemProps;
    loadingOverlay?: LoadingOverlayProps;
    fileUploader?: FileUploadPresentationProps;
    uploadButtonGridItem?: GridItemProps;
    uploadFileButton?: ButtonPresentationProps;
    createButtonGridItem?: GridItemProps;
    createButton?: ButtonPresentationProps;
    imagesGridItem?: GridItemProps;
    imagesLabel?: TypographyProps;
    img?: ImgProps;
    list?: UnorderedListProps;
    listItem?: ListItemProps;
    deleteButton?: ClickablePresentationProps;
}
const formStyles = {
    gridItem: { width: 12 as GridWidths },
    button: {
        css: css`
            ${buttonThemeStyles()}
            width: 100%;
        `,
    },
};
export const scratchAndDentFormStyles: ScratchAndDentFormStyles = {
    container: productLineProps.container,
    sndModeGridItem: { width: 12 },
    sndModeRadioGroup: { horizontal: true },
    formContainer: productLineProps.container,
    parentProductSearchGridItem: formStyles.gridItem,
    originalProductContainerGridItem: formStyles.gridItem,
    originalProductContainer: {
        ...productLineProps.contentContainer,
        css: css`
            ${productLineProps.contentContainer?.css}
            background-color: ${getColor("common.accent")};
            border: 1px solid ${getColor("common.accentContrast")};
            padding: 1em;
        `,
    },
    originalProductLabelGridItem: formStyles.gridItem,
    originalProductLabel: infoProps.label,
    originalProductImageGridItem: {
        width: [3, 2, 1, 1, 1],
        printWidth: 2,
        css: css`
            display: block;
        `,
    },
    productImage: {
        ...productLineProps.image,
        linkWrappingImage: {
            css: css`
                ${productLineProps.image?.linkWrappingImage?.css}
                border: 1px solid ${getColor("common.accentContrast")}
            `,
        },
    },
    originalProductPartNumbersGridItem: {
        width: 8,
        css: css`
            flex-direction: column;
        `,
    },
    productDescription: productLineProps.description,
    serialNumberGridItem: formStyles.gridItem,
    gradeGridItem: formStyles.gridItem,
    additionalDescriptionGridItem: formStyles.gridItem,
    statusGridItem: formStyles.gridItem,
    activateOnGridItem: formStyles.gridItem,
    fileUploadGridItem: { width: [12, 12, 10, 10, 10] },
    loadingOverlay: { minHeight: 80 },
    uploadButtonGridItem: {
        width: [12, 12, 2, 2, 2],
        align: "bottom",
        css: css`
            justify-content: end;
        `,
    },
    uploadFileButton: formStyles.button,
    createButtonGridItem: formStyles.gridItem,
    createButton: formStyles.button,
    imagesGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    imagesLabel: infoProps.label,
    img: {
        css: css`
            height: 90px;
            width: 90px;
        `,
    },
    list: {
        css: css`
            margin-top: ${pxToRem(8)};
        `,
    },
    listItem: {
        css: css`
            display: inline-block;
            margin: ${pxToRem(10, 0, 0, 32)};
        `,
    },
    deleteButton: {
        css: css`
            ${linkActionStyles()}
        `,
    },
};
const sndStatusModel = [
    { value: "Available", label: "Available" },
    { value: "Discarded - Donated", label: "Discarded - Donated" },
    { value: "Discarded - Scrapped", label: "Discarded - Scrapped" },
    { value: "Sold", label: "Sold" },
];

const styles = scratchAndDentFormStyles;
const ScratchAndDentForm = ({
    product,
    originalProduct,
    sndGrades,
    isSearching,
    isSubmitting,
    resetProduct,
    setSndGrades,
    addProduct,
    editProduct,
}: Props) => {
    const [sndMode, setSndMode] = useState(SndMode.Create);
    const [serialNumber, setSerialNumber] = useState("");
    const [grade, setGrade] = useState("");
    const [additionalDescription, setAdditionalDescription] = useState("");
    const [status, setStatus] = useState("");
    const [activateOn, setActivateOn] = useState<Date | undefined>(undefined);
    const [file, setFile] = useState<File>();
    const [incorrectFileExtension, setIncorrectFileExtension] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [imagesInLocalMemory, setImagesInLocalMemory] = useState<FileInfo[]>([]);
    const toasterContext = useContext(ToasterContext);

    useEffect(() => {
        if (!sndGrades) {
            setSndGrades();
        }

        if (product) {
            setSerialNumber(product.properties.sndSerialNumber || "");
            setGrade(product.properties.sndGrade || "");
            setAdditionalDescription(product.properties.sndDescription || "");
            setStatus(product.properties.sndStatus || "");
            setActivateOn(product.properties.activateOn ? new Date(product.properties.activateOn) : undefined);
        }
    }, [product]);

    useEffect(() => {
        if (product && originalProduct && product.images && product.images.length > 0) {
            const images: FileInfo[] = product.images?.map(product => {
                return {
                    IsExistingImage: true,
                    FileName: product.name,
                    FileStream: [],
                    MediumImagePath: product.mediumImagePath,
                    IsDelete: false,
                } as FileInfo;
            });
            setImagesInLocalMemory(images);
        }
    }, [originalProduct]);

    const resizeFile = (file: File): Promise<Blob> =>
        new Promise(resolve => {
            setIsUploading(true);
            Resizer.imageFileResizer(
                file,
                1000,
                1000,
                "JPEG",
                98,
                0,
                blob => {
                    setIsUploading(false);
                    resolve(blob as Blob);
                },
                "blob",
            );
        });

    const fileChangeHandler = async (event: React.ChangeEvent<any>) => {
        let uploadedFile = event.target.files?.[0];
        if (uploadedFile) {
            const resizedBlob = await resizeFile(uploadedFile);
            const resizedFile = new File([resizedBlob], uploadedFile.name, { type: uploadedFile.type });
            setFile(resizedFile);

            const fileExtension = getFileExtension(resizedFile.name);
            const incorrectFileExtension = ["png", "jpg", "jpeg", "gif"].indexOf(fileExtension) === -1;
            setIncorrectFileExtension(incorrectFileExtension);
        } else {
            setFile(undefined);
        }
    };

    const postFile = (fileData: FileInfo) => {
        setImagesInLocalMemory([
            ...imagesInLocalMemory,
            {
                FileStream: fileData.FileStream,
                FileName: fileData.FileName,
                IsDelete: false,
                MediumImagePath: fileData.MediumImagePath,
            },
        ]);
    };

    const onReaderLoad = (fileName: string, fileExtension: string) => {
        return (e: ProgressEvent<FileReader>) => {
            const arrayBuffer = e.target?.result as ArrayBuffer;
            const base64String = btoa(
                new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), ""),
            );
            const fileInfo: FileInfo = {
                FileStream: base64String,
                FileName: fileName,
            };

            if (["png", "jpg", "jpeg", "gif"].includes(fileExtension)) {
                try {
                    postFile(fileInfo);
                } catch (exceptionVar) {
                    setIncorrectFileExtension(true);
                }
            } else {
                setIncorrectFileExtension(true);
            }
        };
    };

    const uploadFileHandler = () => {
        if (isUploading) {
            return;
        }
        setIsUploading(true);
        setUploadCancelled({ uploadCancelled: false });

        if (!file) {
            return;
        }

        const reader = new FileReader();
        reader.onload = onReaderLoad(file.name, getFileExtension(file.name));
        reader.readAsArrayBuffer(file);
        setIsUploading(false);
    };

    const removeFileByIndex = (index: number) => {
        const image = imagesInLocalMemory[index];

        if (image.IsExistingImage) {
            setImagesInLocalMemory(
                imagesInLocalMemory.map((img, i) => {
                    if (i === index) {
                        return { ...image, IsDelete: true } as FileInfo;
                    }
                    return img;
                }),
            );
        } else {
            setImagesInLocalMemory(imagesInLocalMemory.filter((image, i) => index !== i));
        }
    };

    const undoRemoveFileByIndex = (index: number) => {
        const image = imagesInLocalMemory[index];
        setImagesInLocalMemory(
            imagesInLocalMemory.map(i => {
                if (i.FileName === image.FileName) {
                    return { ...image, IsDelete: false } as FileInfo;
                }
                return i;
            }),
        );
    };

    const handleDelete = (image: FileInfo, index: number) => {
        if (image.IsDelete) {
            undoRemoveFileByIndex(index);
        } else {
            removeFileByIndex(index);
        }
    };

    const createSndProduct = (): void => {
        if (!product || grade.length === 0 || status.length === 0) {
            return;
        }

        let formattedActivateOn = "";
        if (activateOn) {
            formattedActivateOn = `${activateOn.getFullYear()}-${activateOn.getMonth() + 1}-${activateOn.getDate()}`;
        }

        const sndProduct = {
            Grade: grade,
            OriginalProductId: originalProduct?.id || product.id,
            AdditionalDescription: additionalDescription,
            SerialNumber: serialNumber,
            Status: status,
            ActivateOn: formattedActivateOn,
            ProductId: product.id || newGuid(),
            Images: imagesInLocalMemory.map(({ FileName, FileStream, IsDelete }) => ({
                FileName,
                FileStream,
                IsDelete: IsDelete?.toString(),
            })),
        } as ScratchAndDentsProductParameter;

        if (sndMode === SndMode.Create) {
            addProduct({
                sndProduct,
                onSuccess: (response: any) => {
                    resetProduct();
                    toasterContext.addToast({
                        body: `${response}. ${translate("Your content will be visible after a site reindex.")}`,
                        messageType: "success",
                    });
                },
                onError: (error: string) => {
                    toasterContext.addToast({
                        body: error || translate("Error creating product"),
                        messageType: "danger",
                        timeoutLength: 18000,
                    });
                },
            });
        } else {
            editProduct({
                sndProduct,
                onSuccess: (response: any) => {
                    resetProduct();
                    toasterContext.addToast({
                        body: `${response}`,
                        messageType: "success",
                    });
                },
                onError: (error: string) => {
                    toasterContext.addToast({
                        body: error || translate("Error editing product"),
                        messageType: "danger",
                        timeoutLength: 18000,
                    });
                },
            });
        }
    };
    const submitHandler = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        createSndProduct();
    };

    const serialNumberChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setSerialNumber(event.target.value);
    };

    const gradeChangeHandler = (event: ChangeEvent<HTMLSelectElement>) => {
        setGrade(event.target.value);
    };

    const additionalDescriptionChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setAdditionalDescription(event.target.value);
    };

    const statusChangeHandler = (event: ChangeEvent<HTMLSelectElement>) => {
        setStatus(event.target.value);
    };

    const activateOnChangeHandler = (event: DatePickerState) => {
        setActivateOn(event.selectedDay);
    };

    const handleChangeSndMode = (event: ChangeEvent<HTMLInputElement>) => {
        setSndMode(event.currentTarget.value as SndMode);
        if (product) {
            resetProduct();
        }
    };
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.sndModeGridItem}>
                <RadioGroup value={sndMode} onChangeHandler={handleChangeSndMode} {...styles.sndModeRadioGroup}>
                    <Radio value={SndMode.Create}>{translate("Creation mode")}</Radio>
                    <Radio value={SndMode.Edit}>{translate("Edition mode")}</Radio>
                </RadioGroup>
            </GridItem>
            <GridItem {...styles.parentProductSearchGridItem}>
                <LoadingOverlay {...styles.loadingOverlay} loading={isSearching || isSubmitting}>
                    <form onSubmit={submitHandler}>
                        <GridContainer {...styles.formContainer}>
                            <GridItem {...styles.parentProductSearchGridItem}>
                                {sndMode === SndMode.Create && (
                                    <ScratchAndDentProductSearch
                                        label={translate("Find the parent product:")}
                                        type="create"
                                    />
                                )}
                                {sndMode === SndMode.Edit && (
                                    <ScratchAndDentProductSearch
                                        label={translate("Find damaged product to edit:")}
                                        type="edit"
                                    />
                                )}
                            </GridItem>
                            {product && (
                                <>
                                    <GridItem {...styles.originalProductContainerGridItem}>
                                        <GridContainer {...styles.originalProductContainer}>
                                            <GridItem {...styles.originalProductLabelGridItem}>
                                                <Typography {...styles.originalProductLabel}>
                                                    {originalProduct
                                                        ? translate("Damaged product being edited:")
                                                        : translate("Original product:")}
                                                </Typography>
                                            </GridItem>
                                            <GridItem {...styles.originalProductImageGridItem}>
                                                <ProductImage
                                                    product={product as any}
                                                    extendedStyles={styles.productImage}
                                                />
                                            </GridItem>
                                            <GridItem {...styles.originalProductPartNumbersGridItem}>
                                                <ProductDescription
                                                    product={product as any}
                                                    extendedStyles={styles.productDescription}
                                                />
                                                <ProductPartNumbers
                                                    productNumber={product.productNumber}
                                                    customerProductNumber={product.customerProductNumber}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                    {originalProduct && (
                                        <GridItem {...styles.originalProductContainerGridItem}>
                                            <GridContainer {...styles.originalProductContainer}>
                                                <GridItem {...styles.originalProductLabelGridItem}>
                                                    <Typography {...styles.originalProductLabel}>
                                                        {translate("Original product:")}
                                                    </Typography>
                                                </GridItem>
                                                <GridItem {...styles.originalProductImageGridItem}>
                                                    <ProductImage
                                                        product={originalProduct as any}
                                                        extendedStyles={styles.productImage}
                                                    />
                                                </GridItem>
                                                <GridItem {...styles.originalProductPartNumbersGridItem}>
                                                    <ProductDescription
                                                        product={originalProduct as any}
                                                        extendedStyles={styles.productDescription}
                                                    />
                                                    <ProductPartNumbers
                                                        productNumber={originalProduct.productNumber}
                                                        customerProductNumber={originalProduct.customerProductNumber}
                                                    />
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>
                                    )}
                                    <GridItem {...styles.serialNumberGridItem}>
                                        <TextField
                                            value={serialNumber}
                                            onChange={serialNumberChangeHandler}
                                            name="serialNumber"
                                            required
                                            type="text"
                                            label={translate("Serial Number:")}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.gradeGridItem}>
                                        <Select
                                            label={translate("Grade:")}
                                            name="grade"
                                            id="name"
                                            onChange={gradeChangeHandler}
                                            required
                                            value={grade}
                                        >
                                            <option value="">{translate("-- Select an option --")}</option>
                                            {sndGrades?.map(grade => {
                                                return (
                                                    <option key={grade.key} value={grade.key}>
                                                        {grade.name}
                                                    </option>
                                                );
                                            })}
                                        </Select>
                                    </GridItem>
                                    <GridItem {...styles.additionalDescriptionGridItem}>
                                        <TextField
                                            name="additionalDescription"
                                            required
                                            type="text"
                                            label={translate("Additional Description:")}
                                            onChange={additionalDescriptionChangeHandler}
                                            value={additionalDescription}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.statusGridItem}>
                                        <Select
                                            label={translate("Status:")}
                                            name="status"
                                            onChange={statusChangeHandler}
                                            required
                                            value={status}
                                        >
                                            <option value="">{translate("-- Select an option --")}</option>
                                            {sndStatusModel.map(status => {
                                                return (
                                                    <option key={status.value} value={status.value}>
                                                        {status.label}
                                                    </option>
                                                );
                                            })}
                                        </Select>
                                    </GridItem>
                                    <GridItem {...styles.activateOnGridItem}>
                                        <DatePicker
                                            label={translate("Activate On:")}
                                            selectedDay={activateOn}
                                            monthAriaLabel={`${translate("Request Pick Up Date optional")}. ${translate(
                                                "Enter month, format M M",
                                            )}`}
                                            dayAriaLabel={`${translate("Request Pick Up Date optional")}. ${translate(
                                                "Enter day, format D D",
                                            )}`}
                                            yearAriaLabel={`${translate("Request Pick Up Date optional")}. ${translate(
                                                "Enter year, format Y Y Y Y",
                                            )}`}
                                            onDayChange={activateOnChangeHandler}
                                        />
                                    </GridItem>
                                    {imagesInLocalMemory.length > 0 && (
                                        <GridItem {...styles.imagesGridItem}>
                                            <Typography {...styles.imagesLabel}>{translate("Images")}</Typography>
                                            <UnorderedList {...styles.list}>
                                                {imagesInLocalMemory.map((image, index) => {
                                                    return (
                                                        <ListItem {...styles.listItem} key={image.FileName}>
                                                            <Img
                                                                {...styles.img}
                                                                css={css`
                                                                    opacity: ${image.IsDelete ? 0.25 : 1};
                                                                `}
                                                                width="90"
                                                                height="90"
                                                                src={`${
                                                                    !image.IsExistingImage
                                                                        ? `data:image/png;base64,${image.FileStream}`
                                                                        : image.MediumImagePath
                                                                }`}
                                                            />
                                                            {image.FileName}
                                                            <Clickable
                                                                {...styles.deleteButton}
                                                                onClick={() => handleDelete(image, index)}
                                                                type="button"
                                                            >
                                                                {image.IsDelete
                                                                    ? translate("Undo Delete")
                                                                    : translate("Delete")}
                                                            </Clickable>
                                                        </ListItem>
                                                    );
                                                })}
                                            </UnorderedList>
                                        </GridItem>
                                    )}
                                    <GridItem {...styles.fileUploadGridItem}>
                                        <FileUpload
                                            {...styles.fileUploader}
                                            fileName={file?.name || ""}
                                            accept=".png, .jpg, .jpeg, .gif"
                                            label={translate("Add Image")}
                                            labelPosition="top"
                                            error={
                                                incorrectFileExtension
                                                    ? translate("must be .png, .jpg, .jpeg or .gif")
                                                    : undefined
                                            }
                                            onFileChange={fileChangeHandler}
                                            uid="scratchAndDentImageFileUpload"
                                            hideButton={true}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.uploadButtonGridItem}>
                                        <Button
                                            {...styles.uploadFileButton}
                                            disabled={!file || isUploading}
                                            onClick={uploadFileHandler}
                                            type="button"
                                        >
                                            {translate("Upload File")}
                                        </Button>
                                    </GridItem>
                                    <GridItem {...styles.createButtonGridItem}>
                                        <Button {...styles.createButton} type="submit" disabled={isUploading}>
                                            {sndMode === SndMode.Create
                                                ? translate("Create")
                                                : translate("Save Changes")}
                                        </Button>
                                    </GridItem>
                                </>
                            )}
                        </GridContainer>
                    </form>
                </LoadingOverlay>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withTheme(ScratchAndDentForm)),
    definition: {
        displayName: "Scratch And Dent Form",
        group: "Common",
    },
};

export default widgetModule;
